import { createContext } from 'react'
export const initBreedsContextValues = {
	breeds: {}
}

const BreedsContext = createContext()
export default BreedsContext
